import "./FrameComponent2.css";

const FrameComponent2 = () => {
  return (
    <header className="navbar-instance-parent">
      <div className="navbar-instance">
        <div className="navbar-parent2">
          <div className="navbar2">
            <div className="title2">
              <div className="heading2">Hello, Raj !</div>
              <div className="sub2">Here’s your dashboard overview.</div>
              <div className="breadcrumbs2">
                <div className="contract8">Contract</div>
                <img className="icon46" alt="" src="/icon-8.svg" />
                <div className="contract9">General Info</div>
                <img className="icon47" alt="" src="/icon-8.svg" />
                <div className="contract10">Scope of Work</div>
                <img className="icon48" alt="" src="/icon-8.svg" />
                <div className="contract11">Payment Details</div>
                <img className="icon49" alt="" src="/icon-8.svg" />
                <div className="general-info2">Sign</div>
              </div>
            </div>
            <div className="right-menu3">
              <div className="button12">
                <img className="icon50" alt="" src="/icon1.svg" />
                <div className="create-a-contract5">SIGNUP/REGISTER</div>
                <img className="icon51" alt="" src="/icon2.svg" />
              </div>
              <div className="icon52">
                <img className="icon53" alt="" src="/icon-13.svg" />
              </div>
              <div className="user2">
                <div className="avatar2">
                  <img className="image-icon2" alt="" src="/image@2x.png" />
                  <img className="check-icon2" alt="" src="/check.svg" />
                </div>
                <div className="text35">
                  <div className="chris-miguel2">Chris Miguel</div>
                  <div className="freelancer2">Freelancer</div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg-in-parent">
            <div className="lg-in">Lg in</div>
            <h1 className="hello-chris">Hello Chris!</h1>
          </div>
        </div>
        <div className="avatar-wrapper">
          <div className="avatar3">
            <img className="image-icon3" alt="" src="/image@2x.png" />
            <img className="check-icon3" alt="" src="/check.svg" />
          </div>
        </div>
      </div>
      <div className="frame-wrapper18">
        <div className="chris-miguel-parent">
          <div className="chris-miguel3">Chris Miguel</div>
          <div className="freelancer3">Freelancer</div>
        </div>
      </div>
    </header>
  );
};

export default FrameComponent2;
